import React, { useState, useContext, createRef, useEffect } from 'react';
import { Dropdown, Header,Menu,Checkbox, Card, Container, Segment, Sticky, Grid, Input, GridRow, Divider, GridColumn, ButtonContent } from 'semantic-ui-react';
import { Button, Form, Icon, Image, List, Label, Transition, Modal } from 'semantic-ui-react';
import { Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import Cookies from 'js-cookie';
import { Loader, Dimmer } from 'semantic-ui-react';
import { dbTasks, dbCaregivers, dbFamMember } from '../../firebase';
import Login from './Login';

const HomePageCaregiver = ({userr}) => {
  
  const someContext = useContext(AppState);
  const {
    pending,
    correct,
    setCorrect,
    familyMembers,
    tasks,
    caregivers,
  } = someContext;
  const [activeItem, setActiveItem] = useState('tasks');
  const {caregiverID} = useParams();
  const contextRef = createRef();
  const [isModalOpenn, setIsModalOpenn] = useState(false);
  const [isDetailOpen, setisDetailModelOpen]=useState(false);
  const [existingTasks,setTasks]=useState([]) ////// this is the variable we gunna use for a task
  const [caregiverId, setCaregiverId]=  useState(caregiverID)
  const [famID, setFamID]=useState("")
  const [famFirstName, setFamFirstName]=useState("");
  const [famLastName, setFamLastName]=useState("");
  const [statuss, setStatus]=useState("");
  const [detailss, setDetails]=useState("");
  const [famPhone, setFamPhone]=useState("");
  const [typee, setType]=useState("");
  const [taskidlist, setTaskidlist]=useState([])
  const [notes,setNotes]=useState("");
  const [title,setTitle]=useState(null);
  const [category,setCategory]=useState(null);
  const [description, setDescription]=useState(null);
  const [key,setKey]=useState(null);



  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
    //   console.log(snappy3.val())
      setFamID(snappy3.val()[caregiverId].familyMembers)
      console.log(snappy3.val()[caregiverId].familyMembers);
      setTasks(snappy3.val()[caregiverId].todolist)
      setNotes(Object.values(snappy3.val()[caregiverId].notes))
    //   console.log(snappy3.val()[caregiverId].notes)
    //   console.log(Object.values(snappy3.val()[caregiverId].notes))
    //   console.log(Object.value(snappy3.val()[caregiverId].notes))
      
    //   console.log("crucial check")
    //   console.log(snappy3.val())
    }
    dbCaregivers.on('value',initialzeName,error=>alert(error));
    return ()=>{dbCaregivers.off('value',initialzeName)}
  }, []);

  useEffect(()=>{
    const  initializeFam = (snappy2) =>{
      if(snappy2.val()[famID]){
      setFamFirstName(snappy2.val()[famID]["firstName"])
    //   console.log(snappy2.val()[famID])
      setFamLastName(snappy2.val()[famID]["lastName"])
      setFamPhone(snappy2.val()[famID]["phone"])
      
      }
//   console.log(famID);
  }
    
    dbFamMember.on('value',initializeFam,error=>alert(error));
    return ()=>{dbFamMember.off('value',initializeFam)}
  }, [famID]);
  
  
  useEffect(() => {
    const handleClose = () => {
      if (caregivers && caregivers[caregiverId] && caregivers[caregiverId]["tasks"]) {
        let a = caregivers[caregiverId]["tasks"];
        // console.log("this is a")
        // console.log(a);
        const result = Object.values(a);
        setTaskidlist(result);
        // console.log(result);
        // console.log("RAN THE INSIDE")

      }
    //   console.log("RAN THE FUNCTION")
    };
    handleClose();
  }, [caregivers]);
  const Category_Array = [
    {
      key: 0,
      text: "Family Update",
      value: "Family Update"
    },
    {
      key: 1,
      text: "Doctor Update",
      value: "Doctor Update"
    }
  ]
  function updateNote2(){
      if(key){          
        dbCaregivers.child(caregiverID).child("notes").child(key).update(
            {category:
            "Doctor"}       )
      }
     
  }
  function updateNote3(){
    if(key){
        console.log("this RAN motherfucker")
        
      dbCaregivers.child(caregiverID).child("notes").child(key).update(
          {category:
          "Daily"}       )
    }
   
}

const PageHeader = () => {
    return (
      <Segment
      basic
      clearing
      style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
      fluid="true"
    >     
      <Menu pointing compact>
          <Menu.Item
            name='home'
            active={activeItem === 'tasks'}
            // onClick={()=>setActiveItem('tasks')}
          />   
          <Menu.Item
            name='Notes'
            active={activeItem === 'notes'}
            // onClick={()=>setActiveItem('notes')}
          /> 
          <Menu.Item
            name='Others Tasks'
            active={activeItem === 'home'}
            // onClick={()=>setActiveItem('home')}
          />
          <Menu.Item
            name='Homecare'
            style={{
              color: 'white',backgroundColor: "#006990"
          }
          }
            active={false}
            // onClick={()=>setActiveItem('tasks')}
          />
      </Menu>

      {/* <Button primary positive floated right circle onClick={()=>setIsModalOpen(true)}>Add Task for {famFirstName}</Button> */}

     
      </Segment>
    );
  };
  function addNote(){
      var key;
      if(notes[0]=="n"){
        key= dbCaregivers.child(caregiverID).child("notes").push({
            "title":document.getElementById("title").value,
            "description":document.getElementById("description").value,
            "createdOn": {'.sv':'timestamp'},

        })

      }
      else{
        //   temp=Object.values(notes)
        //   temp.push()
        key = dbCaregivers.child(caregiverID).child("notes").push({
            "title":document.getElementById("title").value,
            "description":document.getElementById("description").value,
            "createdOn": {'.sv':'timestamp'},
        })
      }
      setKey(key.getKey());
      
    //   console.log(key.getKey())
  }

  const ModalDetail= () =>{
    return(
        <Modal open={isModalOpenn} basic size='small' > 
        {/* onClose={() => setIsModalOpenn(false)} */}
        <Header icon='checkmark' content='Complete!' />
        <Modal.Content>
    <p>
            What type of note is this?
    </p>
        </Modal.Content>
        <Modal.Actions>
    <Button color='green' as={Link} to={`../${caregiverID}`} inverted  onClick={()=>{
          setIsModalOpenn(false);
          setCategory("Doctor");
        updateNote2()}}>
            Medical Update
    </Button>
    <Button color='green' as={Link} to={`../${caregiverID}`}  inverted  onClick={()=>{
        setIsModalOpenn(false);
        setCategory("Daily");
        updateNote3()}}>
            Daily Update
    </Button>
        </Modal.Actions>
      </Modal>
    
        );
  }
  
  const AddNote = () =>
  {return(
    <Container>   
        <Divider hidden>
        </Divider>
        <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h2' textAlign="center">Add a note!</Header>
    <Grid padded textAlign="center">
          <Grid.Row style={{ marginTop: "-5px" }}>
            <Form size="large">
              <Form.Group widths='equal'>
                <Form.Input
                //   onChange={(e) => { setTitle(e.target.value) }}
                  id="title"
                  label='Title'
                //   value={title}
                />
              </Form.Group>
            </Form>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "-15px" }}>
            <Form size="large">
              <Form.Group widths='equal'>
                <Form.Input
                //   onChange={(e) => { setDescription(e.target.value) }}
                  id="description"
                  label='Description:'
                //   value={description}
                // placeholder='Time'
                />
              </Form.Group>
            </Form>
          </Grid.Row>
          {/* <Grid.Row style={{ marginTop: "-15px", marginLeft: "-120px" }}>
            <Header as="h4" content="Category:" />
          </Grid.Row>
         
           */}

          <Grid.Row style={{ marginTop: "5px" }}>
            <Button.Group>
              <Button icon labelPosition='left' as={Link} to={`../${caregiverID}`} >Back<Icon name='cancel' /></Button>
              <Button color='green' submit icon labelPosition='right' onClick={()=>{
                  setIsModalOpenn(true)
                  addNote()
                }
                  }>
                Save
                <Icon name='checkmark' />
              </Button>
            </Button.Group>
          </Grid.Row>
        </Grid>
        </Container>
  )}
//   console.log(isModalOpenn)

  return (
    correct || Cookies.get('caregiverlogged') == caregiverID?
    <div ref={contextRef}>
      <Sticky context={contextRef} >
        <PageHeader />
        <Grid padded textAlign="center">   
       <ModalDetail />
        <AddNote/>
        </Grid>
      </Sticky>
    </div>
    : <Redirect to={'/caregivers'} push={true} />
  );
}

export default HomePageCaregiver;